import { translateWithFallback } from '../utils/translateWithFallback';
import { useTranslation } from '../context/TranslationContext';

type Props = {
    chips: string[];
    selected: string;
    onSelect: (handle: string) => void;
    onReroll?: () => void;
    rerolling?: boolean;
};

const UsernameSuggestionChips = ({ chips, selected, onSelect, onReroll, rerolling }: Props) => {
    const { t } = useTranslation();
    const tr = (key: string, fb: string) => translateWithFallback(t, key, fb);
    if (chips.length === 0) return null;

    const selectedNorm = selected.trim().toLowerCase();

    return (
        <div className="mt-2 space-y-1.5">
            {chips.length > 0 && (
                <div className="flex flex-wrap gap-1.5" role="group" aria-label={tr('page.register.usernameSuggestions', 'Suggestions')}>
                    {chips.map((chip) => {
                        const active = chip.toLowerCase() === selectedNorm;
                        return (
                            <button
                                key={chip}
                                type="button"
                                onClick={() => onSelect(chip)}
                                className={`min-h-9 rounded-full border px-3 py-1 text-xs font-medium transition ${
                                    active
                                        ? 'border-[var(--accent-color)] bg-[var(--accent-color)] text-white'
                                        : 'border-[color-mix(in_srgb,var(--accent-color),transparent_45%)] bg-[color-mix(in_srgb,var(--bg-color),white_35%)] text-[var(--text-color)] hover:border-[var(--accent-color)]'
                                }`}
                            >
                                @{chip}
                            </button>
                        );
                    })}
                </div>
            )}
            {onReroll && (
                <button
                    type="button"
                    onClick={onReroll}
                    disabled={rerolling}
                    className="text-xs font-medium text-[var(--accent-color)] underline-offset-2 hover:underline disabled:opacity-50"
                >
                    {rerolling
                        ? tr('page.register.usernameChecking', 'Checking…')
                        : tr('page.register.usernameReroll', 'Other suggestions')}
                </button>
            )}
        </div>
    );
};

export default UsernameSuggestionChips;
